// Build-time configuration from Vite's env files (.env.<mode>, see .env.example). Nothing here is secret: it is
// all compiled into the public bundle.
const env = import.meta.env;

/** Base URL of the Sensay API, ending with "/". */
export const API_BASE_URL = env.VITE_API_BASE_URL.endsWith('/') ? env.VITE_API_BASE_URL : env.VITE_API_BASE_URL + '/';

/** Whether analytics vendors are loaded and called (on in production builds unless VITE_ANALYTICS=off). */
export const ANALYTICS_ENABLED = env.VITE_ANALYTICS ? env.VITE_ANALYTICS === 'on' : env.PROD;

/** An optional URL from the env files: the production default when the variable is not set; '' when set to nothing. */
const optionalUrl = (value, productionDefault) => (value === undefined ? productionDefault : value);

/**
 * Third-party services the browser calls directly. Not set: the production services. An isolated environment (e.g.
 * the recording regression POC in sw_api2/sensay-regression-poc) points them at local stand-ins; a path such as
 * /mock/... is resolved against the page. Set to nothing, the recording webhook and Google Sign-In are left out.
 */
export const SERVICE_URLS = {
  azureTtsTokenUrl: optionalUrl(env.VITE_AZURE_TTS_TOKEN_URL, 'https://eastasia.api.cognitive.microsoft.com/sts/v1.0/issuetoken'),
  azureSttUrl: optionalUrl(env.VITE_AZURE_STT_URL, 'https://eastasia.stt.speech.microsoft.com/speech/recognition/conversation/cognitiveservices/v1'),
  gcsUploadUrl: optionalUrl(env.VITE_GCS_UPLOAD_URL, 'https://storage.googleapis.com/upload/storage/v1/b/shuoshuo/o'),
  gcsObjectUrl: optionalUrl(env.VITE_GCS_OBJECT_URL, 'https://www.googleapis.com/storage/v1/b/shuoshuo/o/'),
  recordingWebhookUrl: optionalUrl(env.VITE_RECORDING_WEBHOOK_URL, 'https://discord.com/api/webhooks/996701532147957760/wJqIDWJNits-oiOXV4YrUeFgw9ofNQlRf4hjSHfJF4jQ1eHgfVbUcC3Y0ymGDkZj3PMj'),
  googleSignInClientUrl: optionalUrl(env.VITE_GOOGLE_SIGN_IN_URL, 'https://accounts.google.com/gsi/client'),
};
